<template>
  <ion-page>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>TCGCARDMAKER.COM</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding id="foo1">
      <ion-split-pane content-id="main">
        <!--  our side menu  -->
        <ion-menu content-id="main" style="max-width:280px;">
          <!-- <ion-header>
            <ion-toolbar>
              <ion-title>Menu</ion-title>
            </ion-toolbar>
          </ion-header> -->
          <ion-content>
        <ion-list>
           <ion-item>
            <ion-label position="floating">Template</ion-label>
             <ion-select v-bind:value="cardTemplate.content.cardtemplate" @ionChange="cardTemplate.content.cardtemplate=$event.target.value" interface="popover" mode="md">
              <ion-select-option value="V_Basic">Pokemon V</ion-select-option>
              <ion-select-option value="V_Gold_FA">Pokemon V Secret Rare</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Type</ion-label>
             <ion-select v-bind:value="cardTemplate.content.cardtype" @ionChange="cardTemplate.content.cardtype=$event.target.value" interface="popover" mode="md">
              <ion-select-option value="Colorless">Colorless</ion-select-option>
              <ion-select-option value="Dark">Darkness</ion-select-option>
              <ion-select-option value="Fighting">Fighting</ion-select-option>
              <ion-select-option value="Fire">Fire</ion-select-option>
              <ion-select-option value="Grass">Grass</ion-select-option>
              <ion-select-option value="Lightning">Lightning</ion-select-option>
              <ion-select-option value="Metal">Metal</ion-select-option>
              <ion-select-option value="Psychic">Psychic</ion-select-option>
              <ion-select-option value="Water">Water</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Image</ion-label>
            <ion-input @change="handleFileChange($event)" type="file" placeholder="file"></ion-input>
            <div style="display:flex">
              <ion-button color="primary" size="small" @mousedown="moveBG('left',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">◂</ion-button>
              <ion-button color="primary" size="small" @mousedown="moveBG('right',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">▸</ion-button>
              <ion-button color="primary" size="small" @mousedown="moveBG('up',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">▲</ion-button>
              <ion-button color="primary" size="small" @mousedown="moveBG('down',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">▼</ion-button>
              <ion-button color="primary" size="small" @mousedown="moveBG('zoomout',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">-</ion-button>
              <ion-button color="primary" size="small" @mousedown="moveBG('zoomin',true)" @mouseup="moveBGStop()" @mouseout="moveBGStop()">+</ion-button>
            </div>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Card Title</ion-label>
            <ion-input v-bind:value="cardTemplate.content.cardtitle" @ionInput="cardTemplate.content.cardtitle = $event.target.value;"></ion-input>
          </ion-item>
          <ion-item>
             <ion-label position="floating">HP</ion-label>
             <ion-input v-bind:value="cardTemplate.content.cardhp" @ionInput="cardTemplate.content.cardhp = $event.target.value;"></ion-input>
          </ion-item>
          <ion-item v-for="(item, index) in cardTemplate.content.attacks" :key="`attacks-${index}`">
             <ion-label position="stacked">Attack {{index + 1}}</ion-label>
             <div>
              <div style="display:flex;margin-left: -2px;">
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, item.energy1)" fill="clear" v-bind:style="cardTemplate.energies.small[item.energy1.type]"></ion-button>
                </div>
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, item.energy2)" fill="clear" v-bind:style="cardTemplate.energies.small[item.energy2.type]"></ion-button>
                </div>
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, item.energy3)" fill="clear" v-bind:style="cardTemplate.energies.small[item.energy3.type]"></ion-button>
                </div>
                <div class="energybutton">
                 <ion-button color="primary" size="small" @click="showEnergySelector($event, item.energy4)" fill="clear" v-bind:style="cardTemplate.energies.small[item.energy4.type]"></ion-button>
                </div>
                <div style="margin-left: 20px;">
                  <ion-label position="stacked">Damage</ion-label>
                  <ion-input v-bind:value="item.damage" @ionInput="item.damage = $event.target.value;"></ion-input>
                </div>
              </div>
             <div>
               <ion-label position="stacked">Attack Name</ion-label>
               <ion-input v-bind:value="item.name" @ionInput="item.name = $event.target.value;"></ion-input>
             </div>
              <div>
               <ion-label position="stacked">Attack Description</ion-label>
               <ion-textarea v-bind:value="item.description" @ionInput="item.description = $event.target.value;"></ion-textarea>
             </div>
             </div>
             <ion-button color="primary" size="small" @click="removeAttack(index)" fill="clear" style="position: absolute; top:0px; left: 170px">Remove</ion-button>
          </ion-item>
          <ion-item>
             <ion-button color="primary" size="small" @click="addAttack()">Add Another Attack</ion-button>
          </ion-item>
          <ion-item v-for="(item, index) in cardTemplate.content.abilities" :key="`abilities-${index}`">
             <div>
               <ion-label position="stacked">Ability Name</ion-label>
               <ion-input v-bind:value="item.name" @ionInput="item.name = $event.target.value;"></ion-input>
             </div>
              <div>
               <ion-label position="stacked">Ability Description</ion-label>
               <ion-textarea v-bind:value="item.description" @ionInput="item.description = $event.target.value;"></ion-textarea>
             </div>
             <ion-button color="primary" size="small" @click="removeAbility(index)" fill="clear" style="position: absolute; top:0px; left: 170px">Remove</ion-button>
          </ion-item>
          <ion-item>
             <ion-button color="primary" size="small" @click="addAbility()">Add Ability</ion-button>
          </ion-item>
          <ion-item>
             <ion-label position="stacked">Weakness</ion-label>
             <div style="display:flex">
              <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardweakness.energy)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardweakness.energy.type]"></ion-button>
              <ion-input v-bind:value="cardTemplate.content.cardweakness.text" @ionInput="cardTemplate.content.cardweakness.text = $event.target.value;"></ion-input>
             </div>
          </ion-item>
          <ion-item>
             <ion-label position="stacked">Resistance</ion-label>
             <div style="display:flex">
              <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardresist.energy)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardresist.energy.type]"></ion-button>
              <ion-input v-bind:value="cardTemplate.content.cardresist.text" @ionInput="cardTemplate.content.cardresist.text = $event.target.value;"></ion-input>
             </div>
          </ion-item>
          <ion-item>
             <ion-label position="stacked">Retreat Cost</ion-label>
             <div style="display:flex;margin-left: -2px;">
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardretreat.energy1)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy1.type]"></ion-button>
                </div>
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardretreat.energy2)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy2.type]"></ion-button>
                </div>
                <div class="energybutton">
                  <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardretreat.energy3)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy3.type]"></ion-button>
                </div>
                <div class="energybutton">
                 <ion-button color="primary" size="small" @click="showEnergySelector($event, cardTemplate.content.cardretreat.energy4)" fill="clear" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy4.type]"></ion-button>
                </div>
             </div>
          </ion-item>
          <ion-item>
             <ion-label position="floating">Illustrator</ion-label>
             <ion-input v-bind:value="cardTemplate.content.cardillustrator" @ionInput="cardTemplate.content.cardillustrator = $event.target.value;"></ion-input>
          </ion-item>
          <ion-item>
             <ion-label position="floating">Card Number</ion-label>
             <ion-input v-bind:value="cardTemplate.content.cardnumber" @ionInput="cardTemplate.content.cardnumber = $event.target.value;"></ion-input>
          </ion-item>
        </ion-list>
      </ion-content>
        </ion-menu>
        <!-- the main content -->
        <ion-router-outlet id="main" ref="main">
           
        </ion-router-outlet>
      </ion-split-pane>

      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button v-if="!isProduction" @click="toggleImg()">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
        <ion-fab-button @click="exportCanvas()">
          <ion-icon name="download"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>
    <div id="carddiv" v-bind:style="styleObject" :key="cardTemplate.content.cardtemplate">
            <img id="cardframe" v-bind:src="require('../../public/assets/SS_'+cardTemplate.content.cardtemplate+'_'+cardTemplate.content.cardtype+'.png')" v-bind:style="cardTemplate.cardMask"
            />
            <div id="cardnamewrapper" v-bind:style="cardTemplate.cardnamewrapperStyle">
              <!-- <div id="cardname" v-bind:style="cardTemplate.nameStyle">{{cardTemplate.content.cardtitle}}</div> -->
              <div id="cardname" v-bind:style="cardTemplate.nameStyle"><svg-text :text="cardTemplate.content.cardtitle" width="390" autowidth="true" letterspacing="0em" fontfamily="GillSansBold" fontsize="48px" fontcolor="rgba(0,0,0,1)" v-bind:fontstroke="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 'white' : 'none'" v-bind:fontstrokewidth="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 4 : 0"></svg-text></div>
              <div id="cardtype" v-bind:style="cardTemplate.typeVStyle"></div>
            </div>
            <div id="cardhp" v-bind:style="cardTemplate.cardhpStyle">
              <div id="cardhplabel" v-bind:style="cardTemplate.cardhplabelStyle">HP</div>
              <!-- <div id="cardhpnumber" v-bind:style="cardTemplate.cardhpnumberStyle">210</div> -->
              <div id="cardhpnumber" v-bind:style="cardTemplate.cardhpnumberStyle"><svg-text v-bind:text="cardTemplate.content.cardhp" width="100" autowidth="true" letterspacing="-0.06em" fontfamily="FuturaLTBold" fontsize="54px" fontcolor="white" fontstroke="none" fontstrokewidth="0"></svg-text></div>
            </div>
            <div id="cardattacks">
              <div class="cardattacks_wrapper" v-for="(item, index) in cardTemplate.content.abilities" :key="`cardabilities-${index}`">
                <div>
                  <div class="attack_energy ability_icon"></div>
                  <div class="attack_name"><svg-text :text="item.name" width="390" letterspacing="-0.02em" fontfamily="GillSansCondensedBold" fontsize="42px" fontcolor="rgba(156,23,24,1)" fontstroke="white" fontstrokewidth="4"></svg-text></div>
                </div>
                <div style="clear:both"></div>
                <div class="attack_details">
                  <svg-text :text="item.description" width="631" autoheight="true" fontfamily="GillSans" fontsize="27px" fontcolor="rgba(32,32,32,1)" fontstroke="white" fontstrokewidth="4" lineheight="1.07em"></svg-text>
                </div>
              </div>
              <div class="cardattacks_wrapper" v-for="(item, index) in cardTemplate.content.attacks" :key="`cardattacks-${index}`">
                <div>
                <div class="attack_energy">
                  <div v-bind:style="item.energy1.type!='none' ? cardTemplate.energies.large[item.energy1.type] : null"></div>
                  <div v-bind:style="item.energy2.type!='none' ? cardTemplate.energies.large[item.energy2.type] : null" style="margin-left: 2px;"></div>
                  <div v-bind:style="item.energy3.type!='none' ? cardTemplate.energies.large[item.energy3.type] : null" style="margin-left: 2px;"></div>
                  <div v-bind:style="item.energy4.type!='none' ? cardTemplate.energies.large[item.energy4.type] : null" style="margin-left: 2px;"></div>
                </div>
                <div class="attack_name"><svg-text :text="item.name" width="390" letterspacing="-0.02em" fontfamily="GillSansCondensedBold" fontsize="42px" fontcolor="rgba(32,32,32,1)" fontstroke="white" fontstrokewidth="4"></svg-text></div>
                <div class="attack_damage"><svg-text :text="item.damage" width="80" align="end" fontfamily="GillSansCondensedBold" fontsize="42px" fontcolor="rgba(32,32,32,1)" fontstroke="white" fontstrokewidth="4"></svg-text></div>
                </div>
                <div style="clear:both"></div>
                <div class="attack_details">
                  <svg-text :text="item.description" width="631" autoheight="true" fontfamily="GillSans" fontsize="27px" fontcolor="rgba(32,32,32,1)" fontstroke="white" fontstrokewidth="4" lineheight="1.07em"></svg-text>
                </div>
              </div>
             
            </div>
            <div id="cardstats">
              <div id="cardweakness">
                  <div v-if="cardTemplate.content.cardweakness.energy.type!='none'" class="stats_energy" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardweakness.energy.type]"></div>
                  <div v-if="cardTemplate.content.cardweakness.energy.type!='none'" class="stats_x"><img v-bind:src="statsxImg" v-bind:style="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 'filter: invert(1)' : null"/></div>
                  <div v-if="cardTemplate.content.cardweakness.energy.type!='none'" class="stats_weakness"><svg-text v-bind:text="cardTemplate.content.cardweakness.text" width="40" fontfamily="FuturaLTBold" fontsize="28px" v-bind:fontcolor="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 'black' : 'white'" fontstroke="none" fontstrokewidth="0"></svg-text></div>
              </div>
              <div id="cardresistance">
                  <div v-if="cardTemplate.content.cardresist.energy.type!='none'" class="stats_energy" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardresist.energy.type]"></div>
                  <div class="stats_weakness"><svg-text v-bind:text="cardTemplate.content.cardresist.text" width="60" fontfamily="FuturaLTBold" fontsize="28px" v-bind:fontcolor="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 'black' : 'white'" fontstroke="none" fontstrokewidth="0"></svg-text></div>
              </div>
              <div id="cardretreat">
                  <div v-if="cardTemplate.content.cardretreat.energy1.type!='none'" class="stats_energy" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy1.type]"></div>
                  <div v-if="cardTemplate.content.cardretreat.energy2.type!='none'" class="stats_energy retreatpadding" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy2.type]"></div>
                  <div v-if="cardTemplate.content.cardretreat.energy3.type!='none'" class="stats_energy retreatpadding" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy3.type]"></div>
                  <div v-if="cardTemplate.content.cardretreat.energy4.type!='none'" class="stats_energy retreatpadding" v-bind:style="cardTemplate.energies.small[cardTemplate.content.cardretreat.energy4.type]"></div>
              </div>
            </div>
            <div id="cardcredits">
             <div class="credits_illustrator">{{cardTemplate.content.cardillustrator}}</div>
             <div class="credits_set">
               <div class="credits_setimage"><img v-bind:src="setRebelClashImg"/></div>
               <div class="credits_legality"></div>
               <div class="credits_setnumber">{{cardTemplate.content.cardnumber}}</div>
               <div class="credits_rarity rarity_star_white"></div>
             </div>
           </div>
           <div id="cardco" v-bind:style="cardTemplate.content.cardtemplate==='V_Gold_FA' ? 'color:#000' : 'color:#fff'">TCGcardmaker.com</div>
            <img v-bind:src="cardTemplate.compareImg" v-bind:style="cardTemplate.compareStyle" />
          </div>
  </ion-page>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#cardattacks {
  position: absolute;
  bottom: 145px;
  left: 54px;
}

.cardattacks_wrapper {
  margin-bottom: 20px;
}

.attack_energy {
  float: left;
  width: 184px;
  min-height: 1px;
}

.attack_energy div {
  float: left;
}

.attack_name {
  width: 382px;
}

.attack_name, .attack_damage {
  float: left;
  margin-top: 7px;
  max-height: 40px;
  /* font-family: "GillSansCondensedBold";
  font-size: 42px;
  -webkit-text-stroke: 2px #fff; */
}
.attack_damage {
  width: 70px;
}
.attack_details {
  clear: both;
  margin-left: 2px;
  padding-top: 6px;
}

.energy_psychic {
  background: url("../../public/assets/SS_SymbolSheet.png");
  background-position: -515px -188px;
  width: 42px;
  height: 43px;
}

#cardstats {
  position: absolute;
  bottom: 144px;
  left: 119px;
}

.stats_energy {
  float:left;
  width:26px;
  height: 26px;
}

.stats_energy_darkness {
  background: url("../../public/assets/SS_SymbolSheet.png");
  background-position: -247px -364px;
}

.stats_x {
  float:left;
  margin-top: 6px;
  margin-left: 5px;
}

.stats_weakness {
  float: left;
  color: white;
  font-family: "FuturaLTBold";
  font-size: 36px;
  max-height: 40px;
  margin-left: 5px;
}

#cardweakness { 
  position: absolute;
  left:0px;
  width:100px;
}

#cardresistance {
  position: absolute;
  left:195px;
  width:100px;
}

#cardretreat {
  position: absolute;
  left:420px;
  width:200px;
}

#cardcredits {
  position: absolute;
  bottom: 34px;
  left: 51px;
}

.credits_illustrator {
  font-family: "FuturaStdBoldOblique";
  font-size: 13px;
  margin-left: 4px;
  color: rgba(32,32,32,1);
}

.rarity_star_white {
  background: url("../../public/assets/SS_SymbolSheet.png");
  background-position: -428px -545px;
  width: 13px;
  height: 13px;
  margin-left: 6px;
  margin-top: 17px;
}

.credits_set div {
  float: left;
}

.credits_setimage {
  width: 32px;
}

.credits_setnumber {
  font-family: "FrutigerLTStdBoldItalic";
  font-size: 18px;
  margin-left: 10px;
  margin-top: 11px;
  color: rgba(16,16,16,1)
}

.credits_legality {
  background: url("../../public/assets/SS_SymbolSheet.png");
  background-position: -486px -581px;
  width: 19px;
  height: 28px;
  margin-top: 4px;
  margin-left: 13px;
}

#cardco {
  position: absolute;
  bottom: 6px;
  left: 33px;
  font-family: 'BarlowCondensedMedium';
  font-size: 20px;
  color: white;
  letter-spacing: .05em;
  text-transform: lowercase;
}

.smallenergy {
  transform: scale(.7);
  transform-origin: center left;
}

.energybutton {
  margin-top: 8px;
}

.retreatpadding {
  margin-left: 4px;
}

.ability_icon {
  background: url("../../public/assets/SS_SymbolSheet.png");
  background-position: -379px -253px;
  width: 197px;
  height: 38px;
  margin-top: 6px;
  margin-left: -16px;
  margin-right: 3px;
}

</style>

<script>
import html2canvas from "html2canvas";
import { add, download } from "ionicons/icons";
import { addIcons } from "ionicons";
import SvgText from './SvgText.vue';
import EnergySelector from './EnergySelector.vue';

addIcons({
  "ios-add": add.ios,
  "md-add": add.md,
  "md-download": download.md,
  "ios-download": download.ios
});

const imgLink = require("../../public/assets/SS_V_Basic_Psychic.png");
// const compareImg = require("../../public/assets/en_US-SWSH2-092-dragapult_v.jpg"); 
const compareImg = require("../../public/assets/en_US-SWSH1-138-zacian_v.jpg");
const sprites = require("../../public/assets/SS_SymbolSheet.png");
const statsxImg = require("../../public/assets/stats_x.png");
const setRebelClashImg = require("../../public/assets/88_SetIcon_Rebel_Clash.png");
// const maskImg = require("../../public/assets/masktest4.png")

export default {
  data: function() {
    return {
      isProduction: process.env.NODE_ENV === 'production',
      statsxImg: statsxImg,
      setRebelClashImg: setRebelClashImg,
      styleObject: {
        position: "absolute",
        width: "747px",
        height: "1038px",
        backgroundColor: "#fff",
        transformOrigin: "top left",
        background: "url('" + require("../../public/assets/dragapult.jpg") + "')",
        backgroundPosition: "-74px -15px",
        backgroundSize: "120%",
        borderRadius: "40px",
        visibility: "hidden"
      },
      cardTemplate: {
        content: {
          cardtitle: "Dragapult",
          cardhp: "210",
          cardillustrator: "Illus. aky CG Works",
          cardnumber: "092/192",
          cardtype: "Water",
          cardtemplate: "V_Basic",
          abilities: [
            {
              name: "Intrepid Sword",
              description: "Once during your turn, you may look at the top 3 cards of your deck and attach any number of M Energy cards you find there to this Pokemon. Put the other cards into your hand. If you use this Ability, your turn ends."
            }
          ],
          attacks: [
            {
              energy1: {type: "water"},
              energy2: {type: "none"},
              energy3: {type: "none"},
              energy4: {type: "none"},
              name: "Bite",
              damage: "30",
              description: ""
            },
            {
              energy1: {type: "water"},
              energy2: {type: "water"},
              energy3: {type: "none"},
              energy4: {type: "none"},
              name: "Jet Assault",
              damage: "60",
              description: "If this Pokemon moved from your Bench to the Active Spot this turn, this attack does 80 more damage."
            }
          ],
          cardweakness: {
            energy: {
              type: "dark"
            },
            text: "2"
          },
          cardresist: {
            energy: {
              type: "fighting"
            },
            text: "-30"
          },
          cardretreat: {
            energy1: {type: "colorless"},
            energy2: {type: "colorless"},
            energy3: {type: "none"},
            energy4: {type: "none"},
          }
        },
        backgroundImg: imgLink,
        cardMask: {
          // maskImage: "url('"+maskImg+"')",
        },
        compareImg: compareImg,
        cardnamewrapperStyle: {
          position: "absolute",
          top: "36px",
          left: "140px"
        },
        nameStyle: {
          float: "left",
          fontFamily: "GillSansBold",
          fontSize: "48px",
          letterSpacing: "0px",
          transform: "scale(.95,1)",
          transformOrigin: "top left",
          marginLeft: "6px",
          marginTop: "8px"
        },
        compareStyle: {
          position: "absolute",
          top: "1px",
          left: "0px",
          width: "747px",
          /* height: "1038px", */
          display: "none",
          opacity: "100%"
        },
        typeVStyle: {
          background: "url('" + sprites + "')",
          backgroundPosition: "-242px -581px",
          width: "68px",
          height: "52px",
          float: "left",
          marginTop: "4px",
          marginLeft: "-12px"
        },
        cardhpStyle: {
          position: "absolute",
          top: "34px",
          left: "534px"
        },
        cardhplabelStyle: {
          float: "left",
          fontFamily: "GillSansCondensedBold",
          fontSize: "18px",
          letterSpacing: "0px",
          marginTop: "37px",
          color: "#fff"
        },
        cardhpnumberStyle: {
          float: "left",
          // fontFamily: "FuturaLTBold",
          // fontFamily: "GillSansCondensedBold",
          // fontSize: "54px",
          // letterSpacing: "-3px",
          // color: "#fff",
          marginLeft: "2px",
          marginTop: "10px"
        },
        energies: {
          large: {
            'colorless': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-137px -188px",
              width: "42px",
              height: "43px",
            },
            'dark': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-191px -188px",
              width: "42px",
              height: "43px",
            },
            'fighting': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-245px -188px",
              width: "42px",
              height: "43px",
            },
            'fire': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-299px -188px",
              width: "42px",
              height: "43px",
            },
            'grass': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-353px -188px",
              width: "42px",
              height: "43px",
            },
            'lightning': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-407px -188px",
              width: "42px",
              height: "43px",
            },
            'metal': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-461px -188px",
              width: "42px",
              height: "43px",
            },
            'psychic': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-515px -188px",
              width: "42px",
              height: "43px",
            },
            'water': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-569px -188px",
              width: "42px",
              height: "43px",
            },
            'none': {
              background: "url('" + require("../../public/assets/empty_circle.png") + "')",
              backgroundPosition: "0px 0px",
              backgroundSize: "42px 43px",
              width: "42px",
              height: "43px",
            },
          },
          small: {
            'colorless': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-209px -364px",
              width: "26px",
              height: "26px",
            },
            'dark': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-247px -364px",
              width: "26px",
              height: "26px",
            },
            'fighting': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-285px -364px",
              width: "26px",
              height: "26px",
            },
            'fire': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-323px -364px",
              width: "26px",
              height: "26px",
            },
            'grass': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-361px -364px",
              width: "26px",
              height: "26px",
            },
            'lightning': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-399px -364px",
              width: "26px",
              height: "26px",
            },
            'metal': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-437px -364px",
              width: "26px",
              height: "26px",
            },
            'psychic': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-475px -364px",
              width: "26px",
              height: "26px",
            },
            'water': {
              background: "url('" + sprites + "')",
              backgroundPosition: "-513px -364px",
              width: "26px",
              height: "26px",
            },
            'none': {
              background: "url('" + require("../../public/assets/empty_circle.png") + "')",
              backgroundPosition: "0px 0px",
              backgroundSize: "26px 26px",
              width: "26px",
              height: "26px",
            },
          }
        }
      },
      moveBGTimer: true,
    };
  },
  name: "HomePage",
  components: {
    SvgText, 
    /* eslint-disable vue/no-unused-components */
    EnergySelector
  },
  props: {
    msg: String
  },
  mounted() {
    this.$forceNextTick(() => {
        this.waitUntilNonZero('main', this.positionCardDiv);
    });
  },
  updated() {
      console.log("update");
      this.waitUntilNonZero('main', this.positionCardDiv);
  },
  destroyed() {
    window.removeEventListener("resize", this.positionCardDiv);
  },
  created() {
    this.$on("energy-set", this.setEnergy);
    window.addEventListener("resize", this.positionCardDiv);
  },
  computed: {
    cardTemplateChanged() {
      return this.cardTemplate.content.cardtemplate;
    }
  },
  watch: {
    cardTemplateChanged: function (val) {
      console.log("cardTemplateChanged", val);
      // Vue.forceUpdate();
      // this.$forceUpdate();
    }
  },
  methods: {
    addAttack: function() {
      this.cardTemplate.content.attacks.push( {
              energy1: {type: "water"},
              energy2: {type: "none"},
              energy3: {type: "none"},
              energy4: {type: "none"},
              name: "Bite",
              damage: "30",
              description: ""
            });
    },
    addAbility: function() {
      this.cardTemplate.content.abilities.push(  {
              name: "Intrepid Sword",
              description: "Once during your turn, you may look at the top 3 cards of your deck and attach any number of M Energy cards you find there to this Pokemon. Put the other cards into your hand. If you use this Ability, your turn ends."
            });
    },
    removeAttack: function(index) {
      console.log("remove", index);
      this.cardTemplate.content.attacks.splice(index,1);
    },
    removeAbility: function(index) {
      this.cardTemplate.content.abilities.splice(index,1);
    },
    waitUntilNonZero: function(eleid, callback) { // wait for width of element to be non zero so we are sure its rendered asdfasdfasdf
      if ((document.getElementById(eleid).getBoundingClientRect().width!=0) && (document.getElementById(eleid).getBoundingClientRect().x!=0)) {
        callback();
      } else {
        setTimeout(this.waitUntilNonZero, 50, eleid, callback);
      }
    },
    handleFileChange: function(evt) {
     // console.log("file", evt, this.styleObject);

      var reader = new FileReader();
      reader.readAsDataURL(evt.target.files[0]);
      reader.onload = function (e) {
        // console.log(e);
        this.styleObject.background="url("+e.target.result+")";
      }.bind(this);
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    showEnergySelector: function(ev,ref) {
       this.energyref=ref;
       this.$ionic.popoverController.create({
                            component: EnergySelector,
                            componentProps: {
                              parent: this,
                              propsData: {
                               // parent: this
                              }
                            },
                            translucent: true,
                            event: ev
                        })
                        .then(p => p.present())
    },
    setEnergy: function(energy) {
      // console.log("adsf",energy, this.energyref, this.energyref.type);
      this.energyref.type=energy;
      // console.log("after",energy, this.energyref, this.energyref.type);
      this.$ionic.popoverController.dismiss();
    },
    exportCanvas: function() {
      console.log("exportCanvas");
      // window.removeEventListener("resize", this.positionCardDiv);
      html2canvas(document.getElementById("carddiv"), {backgroundColor: 'rgba(0, 0, 0, 0)', removeContainer: true, useCORS: true, allowTaint: true}).then(function(canvas) {
        // document.body.appendChild(canvas);
        var MIME_TYPE = "image/png";

        var imgURL = canvas.toDataURL(MIME_TYPE);

        var dlLink = document.createElement("a");
        dlLink.download = "mypokemon.png";
        dlLink.href = imgURL;
        dlLink.dataset.downloadurl = [
          MIME_TYPE,
          dlLink.download,
          dlLink.href
        ].join(":");

       // var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
       // if (iOS) {
       //   console.log("ios open window");
          // window.open(imgURL,'tcgcardmaker.com','_blank')
       //   window.open().document.write('<img src="' + canvas.toDataURL() + '" />');
       // } else {
          document.body.appendChild(dlLink);
          dlLink.click();
          document.body.removeChild(dlLink);
       //  }
        // window.addEventListener("resize", this.positionCardDiv);
      }.bind(this));
    },
    toggleImg: function() {
      this.cardTemplate.compareStyle.display === "none"
        ? (this.cardTemplate.compareStyle.display = "block")
        : (this.cardTemplate.compareStyle.display = "none");
    },
    positionCardDiv: function() {
      // console.log("positionCardDiv");
        document.getElementById("carddiv").style.visibility="visible";
        let anchorTo = document.getElementById("main").getBoundingClientRect();
        let anchorw = anchorTo.width - 80;
        let anchorh = anchorTo.height - 80;
        let widthratio = anchorw / document.getElementById("carddiv").clientWidth;
        let heightratio = anchorh / document.getElementById("carddiv").clientHeight;
        if (widthratio < 1 || heightratio < 1) {
          document.getElementById("carddiv").style.transform = "scale(" + Math.min(widthratio,heightratio) + ")";
        } else {
          document.getElementById("carddiv").style.transform = "scale(1)";
        }
        document.getElementById("carddiv").style.top = ((anchorTo.height-document.getElementById("carddiv").getBoundingClientRect().height)/2)+parseInt(anchorTo.y) + "px";
        document.getElementById("carddiv").style.left = ((anchorTo.width-document.getElementById("carddiv").getBoundingClientRect().width)/2)+parseInt(anchorTo.x) + "px";
    },
    moveBG: function(direction, start) {
      if (start && !this.moveBGTimer) this.moveBGTimer=true;
      if (this.moveBGTimer) {
        var positions = this.styleObject.backgroundPosition.split(' ')
        var x = parseInt(positions[0]);
        var y = parseInt(positions[1]);
        if (direction==='left') x = x - 1;
        if (direction==='right') x = x + 1;
        if (direction==='up') y = y - 1;
        if (direction==='down') y = y + 1;
        if (['left','right','up','down'].includes(direction)) {
          this.styleObject.backgroundPosition=x+"px "+y+"px";
        } else {
          var size = parseInt(this.styleObject.backgroundSize);
          if (direction==='zoomin') size = size + 1;
          if (direction==='zoomout') size = size - 1;
          this.styleObject.backgroundSize=size+"%";
        }
        setTimeout(this.moveBG,25,direction,false);
      }
      
    },
    moveBGStop: function() {
      this.moveBGTimer=false;  
    }
  }
};
</script>

